"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_CATALOGUE_PICK_ROWS = exports.CatalogueDatasheetAttachOutcome = void 0;
var CatalogueDatasheetAttachOutcome;
(function (CatalogueDatasheetAttachOutcome) {
    CatalogueDatasheetAttachOutcome["Attached"] = "attached";
    CatalogueDatasheetAttachOutcome["NotFound"] = "not_found";
    CatalogueDatasheetAttachOutcome["Superseded"] = "superseded";
    CatalogueDatasheetAttachOutcome["Divided"] = "divided";
})(CatalogueDatasheetAttachOutcome || (exports.CatalogueDatasheetAttachOutcome = CatalogueDatasheetAttachOutcome = {}));
exports.MAX_CATALOGUE_PICK_ROWS = 5000;
//# sourceMappingURL=catalogue-datasheet-attach-outcome.js.map